const parseCookies = () => {
  return document.cookie.split('; ').reduce((left, right) => {
    const [key, val] = right.split('=')
    left[key] = val
    return left
  }, {})
}

const getCookie = key => parseCookies()[key]

const setCookie = (key, val, path = '/') => {
  document.cookie = `${key}=${val}; path=${path}; expires=Fri, 31 Dec 9999 23:59:59 GMT`
}

const removeCookie = (key) => {
  document.cookie = `${key}=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT`
}

export { parseCookies, getCookie, setCookie, removeCookie }



// WEBPACK FOOTER //
// ./src/utils/cookies.js